const state = {
  isMyAccount: false,
  myAccountSelection: {},
  myAccountUploadPath: "",
  myAccountUploadedFiles: {},
  toggleReadyToConnect: null
};

const getters = {
  getIsMyAccount: state => {
    return state.isMyAccount;
  },
  getMyAccountSelection: state => {
    return state.myAccountSelection;
  },
  getMyAccountUploadPath: state => {
    return state.myAccountUploadPath;
  },
  getMyAccountUploadedFiles: state => code => {
    for (var i in state.myAccountUploadedFiles) {
      if (code == state.myAccountUploadedFiles[i].code) {
        return { ...state.myAccountUploadedFiles[i], file: i };
      }
    }
    return null;
  },
  getToggleReadyToConnect: state => {
    return state.toggleReadyToConnect;
  }
};

const mutations = {
  setIsMyAccount: (state, payload) => {
    state.isMyAccount = payload;
  },
  setMyAccountSelection: (state, payload) => {
    state.myAccountSelection = payload;
  },
  setMyAccountUploadedFiles: (state, payload) => {
    state.myAccountUploadedFiles = payload;
  },
  setMyAccountUploadPath: (state, payload) => {
    state.myAccountUploadPath = payload;
  },
  setToggleReadyToConnect: (state, payload) => {
    state.toggleReadyToConnect = payload;
  }
};

const actions = {
  setMyAccount: ({ commit }, payload) => {
    if (payload.isMyAccount) {
      commit("setIsMyAccount", payload.isMyAccount);
      if (payload.myAccountSelection) {
        commit("setMyAccountSelection", payload.myAccountSelection);
      }
      if (payload.myAccountUploadedFiles) {
        commit("setMyAccountUploadedFiles", payload.myAccountUploadedFiles);
      }
      if (payload.myAccountUploadPath) {
        commit("setMyAccountUploadPath", payload.myAccountUploadPath);
      }
      if (payload.toggleReadyToConnect) {
        commit("setToggleReadyToConnect", payload.toggleReadyToConnect);
      }
    }
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
